import React, { useState, useEffect } from 'react';
import superAdminApiClient from '../../../api/superAdminApiClient';
import Pagination from '../../../components/common/Pagination';
import CreateLeadModal from './CreateLeadModal';
import ContentLoader from '../../../components/common/ContentLoader';
import SEO from '../../../components/common/SEO';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { formatDate, getLocalDateString } from '../../../utils/dateUtils';

const LeadListing = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [showModal, setShowModal] = useState(false);

    // Pagination states
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const [filters, setFilters] = useState({
        mobile: '',
        email: '',
        source: '',
        category: '',
        startDate: '',
        endDate: '',
        status: ''
    });

    const fetchLeads = async () => {
        setLoading(true);
        try {
            const params = {
                ...filters,
                page: page,
                limit: 10
            };
            // Clean empty params
            Object.keys(params).forEach(key => {
                if (!params[key]) delete params[key];
            });

            const queryParams = new URLSearchParams(params);
            const response = await superAdminApiClient.get(`/superadmin/leads?${queryParams}`);
            setLeads(response.data.leads);
            setTotalPages(response.data.total_pages);
            setTotalRecords(response.data.total_records);
        } catch (error) {
            console.error('Error fetching leads', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            fetchLeads();
        }, 500);
        return () => clearTimeout(handler);
    }, [filters, page]);

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
        setPage(1);
    };



    return (
        <React.Fragment>
            <SEO
                title="Lead Listing | Mangoloops"
                description="List of all leads on Mangoloops."
            />
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Lead Management</h4>
                        <div>
                            <button className="btn btn-primary" onClick={() => setShowModal(true)}>Create Lead</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row row-cols-1 row-cols-md-5 mb-3 gy-2 gy-md-0">
                <div className="col">
                    <input type="text" className="form-control" placeholder="Lead Mobile" name="mobile" value={filters.mobile} onChange={handleFilterChange} />
                </div>
                <div className="col">
                    <input type="text" className="form-control" placeholder="Lead Email" name="email" value={filters.email} onChange={handleFilterChange} />
                </div>
                <div className="col">
                    <select className="form-select" name="source" value={filters.source} onChange={handleFilterChange}>
                        <option value="">All Sources</option>
                        <option value="Hot">Hot</option>
                        <option value="Manual">Manual</option>
                        <option value="Activity">Activity Lead</option>
                    </select>
                </div>
                <div className="col">
                    <select className="form-select" name="category" value={filters.category} onChange={handleFilterChange}>
                        <option value="">All Categories</option>
                        <option value="holidays">Holidays</option>
                        <option value="hotels">Hotels</option>
                        <option value="cab">Cab</option>
                        <option value="tirth_yatra">Tirth Yatra</option>
                        <option value="medical_tourism">Medical Tourism</option>
                    </select>
                </div>
                <div className="col">
                    <Flatpickr
                        className="form-control"
                        placeholder="Select Date Range"
                        options={{
                            mode: "range",
                            dateFormat: "Y-m-d"
                        }}
                        onChange={(dates) => {
                            if (dates.length === 2) {
                                const start = getLocalDateString(dates[0]);
                                const end = getLocalDateString(dates[1]);
                                setFilters({ ...filters, startDate: start, endDate: end });
                            } else if (dates.length === 0) {
                                setFilters({ ...filters, startDate: '', endDate: '' });
                            }
                            setPage(1);
                        }}
                    />
                </div>
                {/* <div className="col-md-3 mb-2">
                    <select className="form-select" name="status" value={filters.status} onChange={handleFilterChange}>
                        <option value="">All Statuses</option>
                        <option value="open">Open</option>
                        <option value="follow_up">Follow-up</option>
                        <option value="closed">Closed</option>
                        <option value="converted">Converted</option>
                    </select>
                </div> */}
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            {loading ? (
                                <ContentLoader />
                            ) : (
                                <div className="table-responsive">
                                    <table className="table align-middle table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Lead Name</th>
                                                <th>Mobile</th>
                                                <th>Category</th>
                                                <th>City</th>
                                                <th>Source</th>
                                                <th>Created At</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leads.length > 0 ? leads.map((lead) => (
                                                <tr key={lead.id}>
                                                    <td>{lead.name} <br /><small className="text-muted">{lead.email}</small></td>
                                                    <td>{lead.mobile}</td>
                                                    <td><span className="badge bg-info">{lead.category}</span></td>
                                                    <td>{lead.city || 'N/A'}</td>
                                                    <td><span className="badges">{lead.source}</span></td>
                                                    {/* <td>
                                                        <span className={`badge ${lead.latest_status === 'converted' ? 'bg-success' : lead.latest_status === 'closed' ? 'bg-danger' : lead.latest_status === 'follow_up' ? 'bg-warning' : 'bg-info'}`}>
                                                            {(lead.latest_status || 'open').replace('_', ' ').toUpperCase()}
                                                        </span>
                                                    </td> */}
                                                    <td>{formatDate(lead.created_at)}</td>
                                                    <td>
                                                        <a href={`/superadmin/leads/detail/${lead.id}`} className="btn btn-sm btn-primary">View</a>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr><td colSpan="6" className="text-center">No leads found.</td></tr>
                                            )}
                                        </tbody>
                                    </table>

                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div>
                                            Showing {leads.length} of {totalRecords} leads
                                        </div>
                                        <Pagination
                                            currentPage={page}
                                            totalPages={totalPages}
                                            onPageChange={(p) => setPage(p)}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <CreateLeadModal show={showModal} handleClose={() => setShowModal(false)} refreshLeads={fetchLeads} />
        </React.Fragment>
    );
};

export default LeadListing;
